import React, { useState ,useEffect} from 'react';
import { headerGardian } from '../../data/gardian_header';
import MainContainer from "../../components/MainContainer";
import Spacer from '../../components/Spacer';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Paper,
  TextField,
  Typography,
  Box,
  Button,
  InputLabel
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles} from "@material-ui/core";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import SearchIcon from "@mui/icons-material/Search";
import PlanningMissionService from '../../services/PlanningMissionService';
import UserService from '../../services/UserService';
import GardianService from '../../services/GardianService';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: `3px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderRight: 'none',
  },
}));
const useStyles = makeStyles((theme) => ({

}));

const TotalTableRow = styled(TableRow)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.action.hover,
}));

const GardianPresence = () => {
    const classes = useStyles();
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); 

    const begin = new Date(currentYear, currentMonth - 1, 15, 12);
    const end = new Date(currentYear, currentMonth, 15, 12);
    const [direction,setDirection]=useState([]);
    const[selectedDirection,setSelectedDirection]=useState('');
    const [rows,setRows]=useState([]);

    const [filters, setFilters] = useState({
      direction_id: '',
      registration_number: "",
      nom: "",
      date_debut: begin.toISOString().split("T")[0],
      date_fin: end.toISOString().split("T")[0],
    });
    const [employees, setEmployees] = useState([
      {
        id: 1,
        direction: 'Direction 1',
        immatricule: 'EMP001',
        name: 'Dupont Jean',
        function: 'Manager',
        status: 4, 
        congéDays: 0,
        missionDays: 0,
        presenceDays: 0,
        missionFerie: false,
        pointageFerie: false
      },
      // Ajoutez d'autres employés si nécessaire
    ]);

  const calculateTotal = (field) => {
    if (field === 'status') {
      return (statusNum) => employees.filter(emp => emp.status === statusNum).length;
    }
    return employees.reduce((sum, employee) => sum + (employee[field] || 0), 0);
  };

  const updateStatus = (id, newStatus) => {
    setEmployees(employees.map(emp => 
      emp.id === id ? {...emp, status: newStatus} : emp
    ));
  };

  const handleCheckboxChange = (id, field) => (e) => {
    setEmployees(employees.map(emp => 
      emp.id === id ? {...emp, [field]: e.target.checked} : emp
    ));
  };

  const handleChanges = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  }

  
  function loadTable()
  {
    GardianService.presence().then((result) => {
        if (result && result.data) {   
           setRows(result.data);
           console.log("data",result.data);
        }
        }).catch((error) => {
          setRows([]);
        });
  }
  
  
  useEffect(() => {
          const userData = localStorage.getItem('USER');
          if (userData) {
          UserService.getUserSummaryByUserId(userData)
              .then((result) => {
              if (result && result.data) {
                  const dirpers = result.data.direction_id;
                  PlanningMissionService.getDirection().then((result) => {
                  if (result && result.data) {
                      if (parseInt(dirpers, 10) === 1) { 
                      setDirection(result.data);
                      } else {
                        setSelectedDirection(dirpers);
                      setDirection(result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)));
                      }
                  }
                  }).catch((error) => {
                  console.error('Error fetching direction data:', error);
                  });
              }
              })
              .catch((error) => {
              console.error('Error fetching user summary:', error);
              });
          }
          loadTable();
      }, []);
  return (
    <MainContainer {...headerGardian}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Tableau de Présence
        </Typography>
        <Grid container item xs={12} justifyContent="flex-end" alignItems="center">
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              // onClick={handleSubmit}
              startIcon={<SearchIcon />}
              style={{ fontWeight: 600, marginRight: 16 }}
            >
              Rechercher
            </Button>
            <Button
              variant="contained"
              color="success"
              // onClick={handleGenerateFile}  
              startIcon={<DownloadForOfflineIcon />}
              style={{ fontWeight: 600 }}
            >
              Générer
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginTop: 16 }}>
          <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth variant="outlined" size="small">
          <InputLabel id="direction-label">Direction</InputLabel>
          <Select
            labelId="direction-label"
            id="direction-select"
            label="Direction"
            name="direction_id"
            defaultValue={filters.direction_id}
            onChange={handleChanges}
          >
            {selectedDirection !== 1 && (
              <MenuItem value={0}>Tous</MenuItem>
            )}

            {direction.map((ts, index) => (
              <MenuItem key={ts.id || index} value={ts.id}>
                {ts.name} ({ts.code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              id="registration-number"
              label="Matricule"
              size="small"
              variant="outlined"
              fullWidth
              // defaultValue={filters.registration_number}
              name="registration_number"
              onChange={handleChanges}
            />
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              id="name"
              label="Nom et prénom(s)"
              size="small"
              variant="outlined"
              fullWidth
              name="nom"
              onChange={handleChanges}
            />
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}></Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              id="start-date"
              label="Date début"
              size="small"
              variant="outlined"
              fullWidth
              type="date"
              defaultValue={filters.date_debut}
              name="date_debut"
              onChange={handleChanges}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              id="end-date"
              label="Date Fin"
              size="small"
              variant="outlined"
              fullWidth
              type="date"
              defaultValue={filters.date_fin}
              name="date_fin"
              onChange={handleChanges}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
          
        <Spacer y={4} />

        <TableContainer component={Paper}>
          <Table sx={{ borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow>
                <StyledTableCell rowSpan="2">N°</StyledTableCell>
                <StyledTableCell rowSpan="2">Direction</StyledTableCell>
                <StyledTableCell rowSpan="2">Immatricule</StyledTableCell>
                <StyledTableCell rowSpan="2">Nom et Prénom</StyledTableCell>
                <StyledTableCell rowSpan="2">Fonction</StyledTableCell>
                <StyledTableCell colSpan="2" align="center">En congé</StyledTableCell>
                <StyledTableCell rowSpan="2">En congé de maternité ou autres</StyledTableCell>
                <StyledTableCell colSpan="2">Mission</StyledTableCell>
                <StyledTableCell colSpan="2">Pointage manuel</StyledTableCell>
                <StyledTableCell rowSpan="2">Présent</StyledTableCell>
                <StyledTableCell rowSpan="2">Présence Férié</StyledTableCell>
                <StyledTableCell rowSpan="2">Week end férié</StyledTableCell>
                <StyledTableCell rowSpan="2">Absent sans motif</StyledTableCell>
                <StyledTableCell rowSpan="2">Total général</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell>En congé </StyledTableCell>
                <StyledTableCell>En attente</StyledTableCell>
                <StyledTableCell>En mission </StyledTableCell>
                <StyledTableCell>En attente</StyledTableCell>
                <StyledTableCell>Validé </StyledTableCell>
                <StyledTableCell>En attente</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>  
               {rows.map((ts,index)=>
                   <TotalTableRow>
                    <StyledTableCell >{index+1}</StyledTableCell>
                    <StyledTableCell >{ts.direction_code}</StyledTableCell>
                    <StyledTableCell>{ts.registration_number}</StyledTableCell>
                    <StyledTableCell>{ts.nom}</StyledTableCell>
                    <StyledTableCell>{ts.function_name}</StyledTableCell>
                    <StyledTableCell>{ts.conge_valide}</StyledTableCell>
                    <StyledTableCell>{ts.conge_attente}</StyledTableCell>
                    <StyledTableCell>{ts.maternity}</StyledTableCell>
                    <StyledTableCell>{ts.mission_valide}</StyledTableCell>
                    <StyledTableCell>{ts.mission_attente}</StyledTableCell>
                    <StyledTableCell>{ts.timetracking_valide}</StyledTableCell>
                    <StyledTableCell>{ts.timetracking_attente}</StyledTableCell>
                    <StyledTableCell>
                      {employees.filter(e => e.missionFerie).length}
                    </StyledTableCell>
                    <StyledTableCell>{calculateTotal('status')(8)}</StyledTableCell>
                    <StyledTableCell>{calculateTotal('congéDays')}</StyledTableCell>
                    <StyledTableCell>{calculateTotal('missionDays')}</StyledTableCell>
                    <StyledTableCell>{calculateTotal('presenceDays')}</StyledTableCell>
                  </TotalTableRow>
               )}
              {/* <TotalTableRow>
                <StyledTableCell colSpan="5">TOTAL GÉNÉRAL</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(1)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(2)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(3)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(4)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(5)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(6)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(7)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('status')(8)}</StyledTableCell>
                <StyledTableCell>{calculateTotal('congéDays')}</StyledTableCell>
                <StyledTableCell>{calculateTotal('missionDays')}</StyledTableCell>
                <StyledTableCell>{calculateTotal('presenceDays')}</StyledTableCell>
                <StyledTableCell>
                  {employees.filter(e => e.missionFerie).length}
                </StyledTableCell>
              </TotalTableRow> */}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </MainContainer>
  );
};

export default GardianPresence;